import PropTypes from 'prop-types'
import React from 'react'

import bindResource from '../../../../shared_components/BindToStores'
import Button from '../../../../shared_components/Button'
import Container from '../../../../lib/Container'
import Forms from '../../../../shared_components/forms'
import * as Links from '../../../../shared_components/Links'
import Loader from '../../../../shared_components/NewLoader'
import PageTitle from '../../../../shared_components/PageTitle'
import PasswordResetActions from '../../actions/PasswordResetActions'
import routerUtils from '../../../../lib/routerUtils'
import StorePrototype from '../../../../shared_components/StorePrototype'
import usePasswordValidation from '../../../../shared_components/hooks/usePasswordValidation'
import WidthContainer from '../../../../shared_components/WidthContainer'

import './resetPassword.scss'

export class ResetPasswordInner extends React.Component {
  constructor(props) {
    super(props)

    this.changePassword = this.changePassword.bind(this)
    this.onPasswordChange = this.onPasswordChange.bind(this)
    this.state = {
      serverPasswordErrors: [],
      resetErrors: [],
      loading: false,
      processing: false
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.reset_password_token_validation && nextProps.reset_password_token_validation.errors[0] === 'Invalid token') {
      this.setState({loading: true}) // Prevent flicker where form shows then transition happens
      routerUtils.push('/auth/invalid_token/reset_password')
    }
  }

  async changePassword() {
    if (this.refs.form.validate().length === 0) {
      const formData = this.refs.form.formData()

      // Check password against HIBP and weak password list before submitting
      const serverErrors = await this.props.validatePassword(formData.password)
      if (serverErrors.length > 0) {
        this.setState({serverPasswordErrors: [{name: 'password', errors: serverErrors}]})
        return
      }
      this.setState({serverPasswordErrors: [], resetErrors: []})

      this.setState({processing: true})
      PasswordResetActions.changePassword(
        Object.assign(
          formData,
          {reset_password_token: this.props.params.password_reset_token}
        ),
        this.onPasswordChange
      )
    }
  }
  onPasswordChange(data) {
    this.setState({processing: false})
    if (data?.errors?.length) {
      this.setState({resetErrors: data.errors})
    } else {
      this.context.router.push({pathname: '/auth/password/reset-complete'})
    }
  }

  render() {
    return (
      <div className='reset-password'>
        <PageTitle title='Reset Password' />
        <Loader loading={this.props.loadingResetPasswordTokenValidation || this.state.loading}>
          <WidthContainer>
            <h1>Please reset your password.</h1>
            <Forms.Form onSubmit={this.changePassword} ref='form' errors={[...this.props.errors, ...this.state.serverPasswordErrors]} name='password-form'>
              <Forms.Password className='password-control' name='password' label='Choose a new password' />
            </Forms.Form>
            <Forms.Wrapper label=' ' errors={this.state.resetErrors}>
              <Button className='btn-success' loading={this.state.processing || this.props.validating} onClick={this.changePassword}>Change my password</Button>
            </Forms.Wrapper>
          </WidthContainer>
          <div className='support-links'>
            Need Support?<Links.Help>Everplans Help Center</Links.Help>
          </div>
        </Loader>
      </div>
    )
  }
}

ResetPasswordInner.defaultProps = {
  errors: []
}

ResetPasswordInner.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.string),
  reset_password_token_validation: PropTypes.shape({
    errors: PropTypes.arrayOf(PropTypes.string)
  }),
  loadingResetPasswordTokenValidation: PropTypes.bool,
  params: PropTypes.shape({
    password_reset_token: PropTypes.string
  }).isRequired,
  validatePassword: PropTypes.func,
  validating: PropTypes.bool
}
ResetPasswordInner.contextTypes = {router: PropTypes.object}

const ResetPassword = props => {
  const {validatePassword, validating} = usePasswordValidation()
  return <ResetPasswordInner {...props} validatePassword={validatePassword} validating={validating} />
}

Container.registerAction('reset_password_token_validation', PasswordResetActions)
Container.registerStore('reset_password', StorePrototype([PasswordResetActions.Types.DID_CHANGE_PASSWORD]))
export default bindResource(ResetPassword, {id: 'password_reset_token', name: 'reset_password_token_validation', type: 'item'})
